import { connect } from 'react-redux';
import getMarketoCookie from './lib/getMarketoCookie';
import { saveFields } from './data/client.redux';
import { setFlow } from './data/flow.redux';
import App from './App';
import convert from './lib/convert';
import { actions } from './lib/actions';
import { datadogRum } from '@datadog/browser-rum';

const TAX_FLOW_KEY = 'tax';
const TAX_PLAN = 'Tax First';

export const processAndStoreUrlData = urlData => {
  return dispatch => {
    const { client, flow } = urlData;
    if (flow) {
      dispatch(setFlow(flow));

      if (flow === TAX_FLOW_KEY) client.plan = TAX_PLAN;
    }
    dispatch(saveFields(client));

    if (!client.email) return;

    // the mbsy script parses the shortcode from the user's cookie and sets as a global variable
    const shortCode = window.mbsy_short_code || client.mbsy;
    // eslint-disable-next-line no-console
    console.info(`Short Code Sent to Marketo: ${shortCode}`);
    // eslint-disable-next-line no-console
    console.info(`Gclid Sent to Marketo: ${client.gclid}`);

    return convert(actions.PROVIDED_EMAIL, {
      ...client,
      cookie: getMarketoCookie(),
      lastName: client.lastName || 'Not Provided', // lastName required by Salesforce
      mbsyShortCode: shortCode,
    }).catch(error => {
      datadogRum.addError('Provided email Marketo API call failed', error);
    });
  };
};

const mapDispatchToProps = {
  processAndStoreUrlData,
};

export default connect(() => ({}), mapDispatchToProps)(App);
